import { Applicant, DecisionDetailStatuses } from '@/components/pages/Applicant/Applicant.types';

export enum ProductNames {
    FACTORING = 'FACTORING',
    LOADPAY = 'LOADPAY',
    TCSFUEL = 'TcsFuel',
}

export const FACTORING_LOADPAY = 'FACTORING_LOADPAY';

type ProductNameFieldsType = {
    [K in ProductNames]: keyof Applicant;
};

export const ProductNameFields: ProductNameFieldsType = {
    [ProductNames.FACTORING]: 'factoringProduct',
    [ProductNames.LOADPAY]: 'loadPayProduct',
    [ProductNames.TCSFUEL]: 'tcsFuelCardProduct',
};

export interface ApplicantContextProps {
    applicant?: Applicant;
    applicantId?: string;
    applicantPartnerId?: string;
    applicantProductNames: ProductNames[];
    applicantStatus?: DecisionDetailStatuses;
    applicantLoadPayStatus?: DecisionDetailStatuses;
    hasSalesforceLeadLink: boolean;
    hasSalesforceOpportunityLink: boolean;
    productName?: ProductNames;
}
